import { megaMenu, megaMenuResize } from '../__header/MegaMenu';
import Accordion from '../__shortcodes/accordions';
import mirrorHover from '../__utils/mirrorHover';
import Video from '../__utils/video';
import smoothScroll, { markCurrentNavItem } from '../__utils/smoothScroll';
import Forms from '../__utils/forms';
import vhUnit from '../__utils/vhUnit';
import AlertBar from '../__header/AlertBar';
import TECDropdown from '../__utils/TECDropdown';
import TECMobileFilters from "../__utils/TECMobileFilters";
import parallax from '../__utils/parallax';
import HorizontalNav from '../__utils/HorizontalNav';
import ShowMoreExcerpt from '../__utils/ShowMoreExcerpt';

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        document.querySelector('html').classList.remove('no-js');
        megaMenu();
        Accordion.init();
        Video.init();
        mirrorHover();
        smoothScroll();
        vhUnit();
        AlertBar();
        TECDropdown.init();
        TECMobileFilters();
        parallax();
        HorizontalNav.init();
        ShowMoreExcerpt.init();
    },
    loaded() {
        document.querySelector('body').classList.add('page-has-loaded');
        Forms();
        vhUnit();
        parallax();
    },
    resized() {
        HorizontalNav.onResize();
        vhUnit();
        megaMenuResize();
    },
    scrolled() {
        markCurrentNavItem();
        megaMenuResize();
    },
    keyDown(e){

    },
    mouseUp(e) {
    },
};
export default controller;
